import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apiClient } from '@/services/api';
import { Card } from '@/components/layout';
import { usePageConfig } from '@/contexts/PageConfigContext';

export default function VerifyEmailPage() {
  const { t } = useTranslation('common');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async (token: string) => {
      try {
        const response = await apiClient.verifyEmail(token);

        if (response.data.success) {
          setStatus('success');
          setMessage('Email успешно подтвержден! Теперь вы можете пользоваться всеми функциями приложения.');

          // Redirect to home page after 3 seconds
          setTimeout(() => {
            navigate('/');
          }, 3000);
        } else {
          setStatus('error');
          setMessage(response.data.message || 'Не удалось подтвердить email');
        }
      } catch (error: any) {
        console.error('Email verification error:', error);
        setStatus('error');

        const errorMessage = error.response?.data?.message ||
                            error.response?.data?.error ||
                            'Произошла ошибка при подтверждении email';
        setMessage(errorMessage);
      }
    };

    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Отсутствует токен верификации');
      return;
    }

    verifyEmail(token);
  }, [searchParams, navigate]);


  usePageConfig({ title: t('emailVerification'), showHeader: false, showBottomNav: false, showNavigation: false });

  return (
    <div className="ls-flex ls-align-center ls-justify-center" style={{ minHeight: '80vh' }}>
      <Card className="ls-text-center" style={{ maxWidth: '400px', width: '100%' }}>
          {status === 'loading' && (
            <>
              <div className="ls-mb-4">
                <div className="animate-spin rounded-full h-16 w-16 border-b-2" style={{ borderColor: 'var(--accent-primary)', margin: '0 auto' }}></div>
              </div>
              <h2 className="ls-h2 ls-mb-2">Подтверждение email...</h2>
              <p className="theme-text-secondary" style={{ fontSize: '13px' }}>
                Пожалуйста, подождите
              </p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="ls-mb-4">
                <div
                  className="ls-flex ls-align-center ls-justify-center"
                  style={{
                    width: '64px',
                    height: '64px',
                    background: 'var(--bg-status-success)',
                    borderRadius: '50%',
                    margin: '0 auto'
                  }}
                >
                  <svg className="theme-status-success" width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
              <h2 className="ls-h2 ls-mb-2">Email подтвержден!</h2>
              <p className="theme-text-secondary ls-mb-4" style={{ fontSize: '13px' }}>
                {message}
              </p>
              <p className="theme-text-muted ls-mb-4" style={{ fontSize: '11px' }}>
                Вы будете перенаправлены на главную страницу через несколько секунд...
              </p>
              <button
                onClick={() => navigate('/')}
                className="ls-btn"
              >
                Перейти на главную
              </button>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="ls-mb-4">
                <div
                  className="ls-flex ls-align-center ls-justify-center"
                  style={{
                    width: '64px',
                    height: '64px',
                    background: 'var(--bg-error)',
                    borderRadius: '50%',
                    margin: '0 auto'
                  }}
                >
                  <svg className="theme-text-error" width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </div>
              </div>
              <h2 className="ls-h2 ls-mb-2">Ошибка верификации</h2>
              <p className="theme-text-secondary ls-mb-4" style={{ fontSize: '13px' }}>
                {message}
              </p>
              <div className="ls-flex ls-flex-col ls-gap-2">
                <button
                  onClick={() => navigate('/')}
                  className="ls-btn"
                >
                  На главную
                </button>
                <button
                  onClick={() => window.location.reload()}
                  className="ls-btn ls-btn--outlined"
                >
                  Попробовать снова
                </button>
              </div>
            </>
          )}
      </Card>
    </div>
  );
}
